import script from "./ContractManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractManagement.vue?vue&type=script&setup=true&lang=js"

import "./ContractManagement.vue?vue&type=style&index=0&id=9b5ea3b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b5ea3b0"]])

export default __exports__